var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("a-spin", { attrs: { spinning: _vm.loading } }, [
    _c(
      "div",
      { staticClass: "app-container" },
      [
        _c(
          "div",
          { staticClass: "fixedButton" },
          [
            !_vm.showSaveBtn
              ? _c(
                  "vxe-button",
                  {
                    staticClass: "examineButton",
                    on: { click: _vm.ReturnFun },
                  },
                  [_vm._v("返回")]
                )
              : _vm._e(),
            !_vm.showSaveBtn && _vm.showPublish1
              ? _c(
                  "vxe-button",
                  { attrs: { status: "primary" }, on: { click: _vm.editFun } },
                  [_vm._v("编辑")]
                )
              : _vm._e(),
            _vm.showSaveBtn
              ? _c(
                  "vxe-button",
                  {
                    staticClass: "examineButton",
                    on: { click: _vm.cancelFun },
                  },
                  [_vm._v("取消")]
                )
              : _vm._e(),
            (!_vm.showSaveBtn || _vm.showPublish) && !_vm.activityTimeIsPast
              ? _c(
                  "vxe-button",
                  {
                    attrs: { status: "success" },
                    on: {
                      click: function ($event) {
                        return _vm.saveFun(0)
                      },
                    },
                  },
                  [_vm._v("保存")]
                )
              : _vm._e(),
            _vm.showPublish
              ? _c(
                  "vxe-button",
                  {
                    directives: [{ name: "waves", rawName: "v-waves" }],
                    staticClass: "examineButton",
                    attrs: { status: "success" },
                    on: {
                      click: function ($event) {
                        return _vm.saveFun(1)
                      },
                    },
                  },
                  [_vm._v("发布")]
                )
              : _vm._e(),
          ],
          1
        ),
        _c(
          "div",
          {
            staticClass: "CertificateReleaseApplicationBox scrollBars",
            style: "height:" + (_vm.$store.state.app.height - 80) + "px;",
          },
          [
            _c(
              "div",
              { staticClass: "item-line", staticStyle: { margin: "0px" } },
              [_vm._v("活动计划信息")]
            ),
            _c(
              "div",
              { staticClass: "budgetBox bodyBox" },
              [
                _c(
                  "a-form-model",
                  {
                    ref: "activityForm",
                    staticClass: "UniformCss",
                    attrs: {
                      inline: true,
                      model: _vm.activity,
                      rules: _vm.rules,
                      "label-width": "100px",
                    },
                  },
                  [
                    _c(
                      "a-row",
                      [
                        _c(
                          "a-col",
                          { attrs: { span: 12 } },
                          [
                            _c(
                              "a-form-model-item",
                              {
                                attrs: {
                                  label: "市场活动来源",
                                  prop: "selectedOrgText",
                                },
                              },
                              [
                                _c("a-select", {
                                  ref: "selectOrgPopup",
                                  staticClass: "sourceSelect",
                                  attrs: {
                                    placeholder: "选择活动来源",
                                    disabled: _vm.editDisabled,
                                  },
                                  nativeOn: {
                                    click: function ($event) {
                                      return _vm.showTree.apply(null, arguments)
                                    },
                                  },
                                  model: {
                                    value: _vm.selectedOrgText,
                                    callback: function ($$v) {
                                      _vm.selectedOrgText = $$v
                                    },
                                    expression: "selectedOrgText",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "a-row",
                      [
                        _c(
                          "a-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "a-form-model-item",
                              { attrs: { label: "活动名称", prop: "actName" } },
                              [
                                _c("a-input", {
                                  attrs: { disabled: "" },
                                  model: {
                                    value: _vm.activity.actName,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.activity, "actName", $$v)
                                    },
                                    expression: "activity.actName",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "a-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "a-form-model-item",
                              {
                                attrs: {
                                  label: "政策立项编号",
                                  prop: "projectCode",
                                },
                              },
                              [
                                _c("a-input", {
                                  attrs: { disabled: _vm.editDisabled },
                                  model: {
                                    value: _vm.activity.projectCode,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.activity, "projectCode", $$v)
                                    },
                                    expression: "activity.projectCode",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "a-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "a-form-model-item",
                              {
                                attrs: {
                                  label: "生效时间",
                                  prop: "planStartTime",
                                },
                              },
                              [
                                _c("a-date-picker", {
                                  attrs: {
                                    type: "date",
                                    format: _vm.dateFormat,
                                    "value-format": "YYYY-MM-DD HH:mm:ss",
                                    disabled: _vm.editDisabled,
                                  },
                                  model: {
                                    value: _vm.activity.planStartTime,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.activity,
                                        "planStartTime",
                                        $$v
                                      )
                                    },
                                    expression: "activity.planStartTime",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "a-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "a-form-model-item",
                              {
                                attrs: {
                                  label: "失效时间",
                                  prop: "planEndTime",
                                },
                              },
                              [
                                _c("a-date-picker", {
                                  attrs: {
                                    type: "date",
                                    format: _vm.dateFormat,
                                    "value-format": "YYYY-MM-DD HH:mm:ss",
                                    "disabled-date": _vm.disabledTime,
                                    disabled: _vm.activityTimeIsPast,
                                  },
                                  model: {
                                    value: _vm.activity.planEndTime,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.activity, "planEndTime", $$v)
                                    },
                                    expression: "activity.planEndTime",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "a-row",
                      [
                        _c(
                          "a-col",
                          {
                            staticStyle: { height: "auto" },
                            attrs: { span: 18 },
                          },
                          [
                            _c(
                              "a-form-model-item",
                              { attrs: { label: "其他说明", prop: "remarks" } },
                              [
                                _c("el-input", {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    type: "textarea",
                                    disabled: "",
                                    maxlength: "400",
                                    "show-word-limit": "",
                                    autosize: { minRows: 4, maxRows: 6 },
                                  },
                                  model: {
                                    value: _vm.activity.remarks,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.activity, "remarks", $$v)
                                    },
                                    expression: "activity.remarks",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "item-line", staticStyle: { margin: "0px" } },
              [_vm._v("核销信息")]
            ),
            _c(
              "div",
              { staticClass: "budgetBox bodyBox" },
              [
                _c("a-form-model", [
                  _c(
                    "div",
                    { staticStyle: { "margin-left": "2%" } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          staticStyle: { "margin-bottom": "5px" },
                          attrs: { label: "核销规则描述" },
                        },
                        [
                          _c("el-input", {
                            staticStyle: { width: "80%" },
                            attrs: {
                              type: "textarea",
                              disabled: _vm.editDisabled,
                              maxlength: "400",
                              "show-word-limit": "",
                              autosize: { minRows: 4, maxRows: 6 },
                            },
                            model: {
                              value: _vm.activity.writeOffRules,
                              callback: function ($$v) {
                                _vm.$set(_vm.activity, "writeOffRules", $$v)
                              },
                              expression: "activity.writeOffRules",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "a-form-model-item",
                        {
                          staticStyle: { "margin-bottom": "5px" },
                          attrs: { label: "核销材料说明" },
                        },
                        [
                          _c("el-input", {
                            staticStyle: { width: "80%" },
                            attrs: {
                              type: "textarea",
                              disabled: _vm.editDisabled,
                              maxlength: "400",
                              "show-word-limit": "",
                              autosize: { minRows: 4, maxRows: 6 },
                            },
                            model: {
                              value: _vm.activity.writeOffMaterial,
                              callback: function ($$v) {
                                _vm.$set(_vm.activity, "writeOffMaterial", $$v)
                              },
                              expression: "activity.writeOffMaterial",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "a-form-model-item",
                        { attrs: { label: "核销其他说明" } },
                        [
                          _c("el-input", {
                            staticStyle: { width: "80%" },
                            attrs: {
                              type: "textarea",
                              disabled: _vm.editDisabled,
                              maxlength: "400",
                              "show-word-limit": "",
                              autosize: { minRows: 4, maxRows: 6 },
                            },
                            model: {
                              value: _vm.activity.writeOffOther,
                              callback: function ($$v) {
                                _vm.$set(_vm.activity, "writeOffOther", $$v)
                              },
                              expression: "activity.writeOffOther",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "item-line", staticStyle: { margin: "0px" } },
              [_vm._v("下发对象及费用额度标准")]
            ),
            _c("div", { staticClass: "budgetBox bodyBox" }, [
              _c(
                "div",
                {
                  staticStyle: {
                    "padding-bottom": "5px",
                    "margin-left": "1%",
                    display: "flex",
                  },
                },
                [
                  _c(
                    "a-form-model",
                    {
                      staticClass: "select-form",
                      staticStyle: { display: "flex", "flex-wrap": "wrap" },
                    },
                    [
                      _c(
                        "a-space",
                        [
                          _c(
                            "a-form-model-item",
                            {
                              staticStyle: { margin: "10px" },
                              attrs: { label: "经销商名称" },
                            },
                            [
                              _c("a-input", {
                                staticStyle: { width: "200px" },
                                attrs: { placeholder: "请输入经销商名称" },
                                nativeOn: {
                                  keyup: function ($event) {
                                    if (
                                      !$event.type.indexOf("key") &&
                                      _vm._k(
                                        $event.keyCode,
                                        "enter",
                                        13,
                                        $event.key,
                                        "Enter"
                                      )
                                    ) {
                                      return null
                                    }
                                    return _vm.queryByPageActDb.apply(
                                      null,
                                      arguments
                                    )
                                  },
                                },
                                model: {
                                  value: _vm.conditions.dealerName,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.conditions, "dealerName", $$v)
                                  },
                                  expression: "conditions.dealerName",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "a-form-model-item",
                            {
                              staticStyle: { margin: "10px" },
                              attrs: { label: "经理部" },
                            },
                            [
                              _c(
                                "a-select",
                                {
                                  staticStyle: { width: "120px" },
                                  attrs: { placeholder: "请选择经理部" },
                                  model: {
                                    value: _vm.conditions.sectorId,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.conditions, "sectorId", $$v)
                                    },
                                    expression: "conditions.sectorId",
                                  },
                                },
                                [
                                  _c(
                                    "a-select-option",
                                    { attrs: { label: "全部", value: null } },
                                    [_vm._v("全部")]
                                  ),
                                  _vm._l(_vm.sectorList, function (item) {
                                    return _c(
                                      "a-select-option",
                                      {
                                        key: item.deptId,
                                        attrs: { value: item.deptId },
                                      },
                                      [_vm._v(_vm._s(item.deptName))]
                                    )
                                  }),
                                ],
                                2
                              ),
                            ],
                            1
                          ),
                          _c(
                            "a-form-model-item",
                            {
                              staticStyle: { margin: "10px" },
                              attrs: { label: "省" },
                            },
                            [
                              _c(
                                "a-select",
                                {
                                  staticStyle: { width: "150px" },
                                  attrs: { placeholder: "请选择省" },
                                  on: { change: _vm.changeProvince },
                                  model: {
                                    value: _vm.conditions.provinceId,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.conditions,
                                        "provinceId",
                                        $$v
                                      )
                                    },
                                    expression: "conditions.provinceId",
                                  },
                                },
                                [
                                  _c(
                                    "a-select-option",
                                    { attrs: { label: "全部", value: null } },
                                    [_vm._v("全部")]
                                  ),
                                  _vm._l(_vm.provinceList, function (item) {
                                    return _c(
                                      "a-select-option",
                                      {
                                        key: item.provinceId,
                                        attrs: { value: item.provinceCode },
                                      },
                                      [_vm._v(_vm._s(item.provinceName))]
                                    )
                                  }),
                                ],
                                2
                              ),
                            ],
                            1
                          ),
                          _c(
                            "a-form-model-item",
                            {
                              staticStyle: { margin: "10px" },
                              attrs: { label: "城市" },
                            },
                            [
                              _c(
                                "a-select",
                                {
                                  staticStyle: { width: "150px" },
                                  attrs: { placeholder: "城市" },
                                  model: {
                                    value: _vm.conditions.cityId,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.conditions, "cityId", $$v)
                                    },
                                    expression: "conditions.cityId",
                                  },
                                },
                                _vm._l(_vm.cityList, function (item) {
                                  return _c(
                                    "a-select-option",
                                    {
                                      key: item.cityId,
                                      attrs: { value: item.cityCode },
                                    },
                                    [_vm._v(_vm._s(item.cityName))]
                                  )
                                }),
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "div",
                [
                  _c(
                    "vxe-button",
                    {
                      attrs: { status: "primary" },
                      on: { click: _vm.queryByPageActDb },
                    },
                    [_vm._v("搜索")]
                  ),
                  _c(
                    "vxe-button",
                    {
                      attrs: { status: "info" },
                      on: { click: _vm.clearData1 },
                    },
                    [_vm._v("重置")]
                  ),
                  _c(
                    "vxe-button",
                    {
                      directives: [{ name: "waves", rawName: "v-waves" }],
                      attrs: {
                        loading: _vm.dealerAddBtnLoading,
                        status: "primary",
                        disabled: _vm.activityTimeIsPast,
                      },
                      on: { click: _vm.goDistributorList },
                    },
                    [_vm._v("添加")]
                  ),
                  _c(
                    "vxe-button",
                    {
                      attrs: { status: "primary" },
                      on: { click: _vm.uploadFun },
                    },
                    [_vm._v("导入商家")]
                  ),
                  _c(
                    "vxe-button",
                    {
                      attrs: {
                        status: "primary",
                        disabled: _vm.activityTimeIsPast,
                      },
                      on: { click: _vm.editExecuteFreqDialog },
                    },
                    [_vm._v("批量修改频次")]
                  ),
                ],
                1
              ),
              _c(
                "div",
                [
                  _c(
                    "el-form",
                    {
                      ref: "modelTableBaseFormRef",
                      attrs: {
                        model: _vm.modelTableBase,
                        "label-width": "14px",
                      },
                    },
                    [
                      _c(
                        "vxe-table",
                        {
                          directives: [
                            {
                              name: "loading",
                              rawName: "v-loading",
                              value: _vm.modelTableBase.loading,
                              expression: "modelTableBase.loading",
                            },
                          ],
                          staticClass: "mytable-scrollbar tableOvf",
                          staticStyle: { "margin-top": "10px" },
                          attrs: {
                            border: "",
                            align: "center",
                            "show-header-overflow": "",
                            "show-overflow": "",
                            "column-config": { resizable: true },
                            stripe: "",
                            round: "",
                            "max-height":
                              _vm.$store.state.app.height - 300 > 200
                                ? _vm.$store.state.app.height - 200
                                : 200,
                            "scroll-y": { enabled: false },
                            "row-config": { isHover: true },
                            data: _vm.pageSelectedDealers,
                          },
                          on: {
                            "checkbox-change": _vm.handleDealerSelectionChange,
                            "checkbox-all": _vm.handleDealerSelectionChange,
                          },
                        },
                        [
                          _c("vxe-column", {
                            attrs: {
                              type: "checkbox",
                              width: "60",
                              align: "center",
                            },
                          }),
                          _c("vxe-column", {
                            attrs: {
                              type: "seq",
                              title: "序号",
                              width: "60",
                              align: "center",
                            },
                          }),
                          _c("vxe-column", {
                            attrs: {
                              title: "经理部",
                              field: "sectorName",
                              width: "150",
                            },
                          }),
                          _c("vxe-column", {
                            attrs: {
                              title: "经销商名称",
                              field: "dealerName",
                              width: "200",
                            },
                          }),
                          _c("vxe-column", {
                            attrs: { title: "费用额度(元)" },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          label: " ",
                                          prop:
                                            "data." +
                                            (scope.seq - 1) +
                                            ".feeLimit",
                                          rules: [
                                            {
                                              required: true,
                                              message: "请输入费用额度!",
                                              trigger: "blur",
                                            },
                                          ],
                                        },
                                      },
                                      [
                                        _c("a-input", {
                                          attrs: {
                                            placeholder: "请输入",
                                            oninput:
                                              "value=value.replace(/\\D/g, '')",
                                            disabled: !!scope.row.id,
                                          },
                                          model: {
                                            value: scope.row.feeLimit,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                scope.row,
                                                "feeLimit",
                                                $$v
                                              )
                                            },
                                            expression: "scope.row.feeLimit",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ]
                                },
                              },
                            ]),
                          }),
                          _c("vxe-column", {
                            attrs: { title: "核销比例(%)" },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          label: " ",
                                          prop:
                                            "data." +
                                            (scope.seq - 1) +
                                            ".writeRate",
                                          rules: [
                                            {
                                              required: true,
                                              message: "请输入核销比例!",
                                              trigger: "blur",
                                            },
                                          ],
                                        },
                                      },
                                      [
                                        _c("a-input", {
                                          attrs: {
                                            placeholder: "请输入",
                                            disabled: !!scope.row.id,
                                          },
                                          on: {
                                            input: function ($event) {
                                              return _vm.handleWriteRateInput(
                                                scope.row,
                                                "writeRate"
                                              )
                                            },
                                          },
                                          model: {
                                            value: scope.row.writeRate,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                scope.row,
                                                "writeRate",
                                                $$v
                                              )
                                            },
                                            expression: "scope.row.writeRate",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ]
                                },
                              },
                            ]),
                          }),
                          _c("vxe-column", {
                            attrs: { title: "执行频次" },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          label: " ",
                                          prop:
                                            "data." +
                                            (scope.seq - 1) +
                                            ".executeFreq",
                                          rules: [
                                            {
                                              required: true,
                                              message: "请输入执行频次!",
                                              trigger: "blur",
                                            },
                                          ],
                                        },
                                      },
                                      [
                                        _c("a-input", {
                                          attrs: {
                                            placeholder: "请输入",
                                            disabled:
                                              !!scope.row.id &&
                                              _vm.activityTimeIsPast,
                                          },
                                          on: {
                                            input: function (e) {
                                              return (scope.row.executeFreq =
                                                e.target.value.replace(
                                                  /[^\d]/g,
                                                  ""
                                                ))
                                            },
                                          },
                                          model: {
                                            value: scope.row.executeFreq,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                scope.row,
                                                "executeFreq",
                                                $$v
                                              )
                                            },
                                            expression: "scope.row.executeFreq",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ]
                                },
                              },
                            ]),
                          }),
                          _vm.activity.planStatus === "1"
                            ? _c("vxe-column", {
                                attrs: {
                                  title: "操作",
                                  width: "170",
                                  fixed: "right",
                                  align: "center",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function (ref) {
                                        var row = ref.row
                                        return [
                                          _c(
                                            "div",
                                            { staticClass: "handle-box" },
                                            [
                                              row.id
                                                ? _c(
                                                    "a-button",
                                                    {
                                                      attrs: {
                                                        type: "link",
                                                        icon: "el-icon-edit",
                                                      },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.editDlrFun(
                                                            row
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [_vm._v("编辑")]
                                                  )
                                                : _vm._e(),
                                              _c(
                                                "a-button",
                                                {
                                                  attrs: {
                                                    type: "link",
                                                    icon: "el-icon-delete",
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.deleteFun(row)
                                                    },
                                                  },
                                                },
                                                [_vm._v("删除")]
                                              ),
                                            ],
                                            1
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  3566042520
                                ),
                              })
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c("vxe-pager", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: !_vm.modelTableBase.loading,
                        expression: "!modelTableBase.loading",
                      },
                    ],
                    attrs: {
                      "current-page": _vm.pagination.current,
                      "page-size": _vm.pagination.size,
                      total: _vm.pagination.total,
                      "page-sizes": [10, 15, 20, 50, 100],
                      layouts: [
                        "PrevPage",
                        "JumpNumber",
                        "NextPage",
                        "FullJump",
                        "Sizes",
                        "Total",
                      ],
                    },
                    on: { "page-change": _vm.changePage },
                  }),
                ],
                1
              ),
            ]),
          ]
        ),
        _c(
          "a-modal",
          {
            attrs: {
              title: "选择三级来源",
              visible: _vm.showTreeDialog,
              center: "",
              width: "40%",
            },
            on: {
              "update:visible": function ($event) {
                _vm.showTreeDialog = $event
              },
              cancel: _vm.handleDialogCancel,
            },
          },
          [
            _vm.showTreeDialog
              ? _c("FiveSourceTree", {
                  ref: "sourceTree",
                  attrs: {
                    "tree-data": _vm.treeData,
                    "check-key": _vm.checkKey,
                  },
                })
              : _vm._e(),
            _c(
              "span",
              {
                staticClass: "dialog-footer",
                attrs: { slot: "footer" },
                slot: "footer",
              },
              [
                _c("vxe-button", { on: { click: _vm.handleDialogCancel } }, [
                  _vm._v("取 消"),
                ]),
                _c(
                  "vxe-button",
                  {
                    attrs: { type: "primary" },
                    on: { click: _vm.handleDialogConfirm },
                  },
                  [_vm._v("确 定")]
                ),
              ],
              1
            ),
          ],
          1
        ),
        _c(
          "a-modal",
          {
            attrs: {
              title: "导入Excel",
              visible: _vm.uploadDialog,
              width: "400px",
              footer: null,
            },
            on: {
              "update:visible": function ($event) {
                _vm.uploadDialog = $event
              },
              cancel: function () {
                return (_vm.uploadDialog = false)
              },
            },
          },
          [
            _c(
              "div",
              {
                directives: [
                  {
                    name: "loading",
                    rawName: "v-loading",
                    value: _vm.importLoading,
                    expression: "importLoading",
                  },
                ],
                staticClass: "faultAdd",
              },
              [
                _c("div", { staticClass: "model-box" }, [
                  _c(
                    "a",
                    {
                      staticClass: "load-buttom",
                      on: { click: _vm.downloadTemplate },
                    },
                    [
                      _c("i", { staticClass: "el-icon-download" }),
                      _vm._v("下载示例模板"),
                    ]
                  ),
                ]),
                _c(
                  "el-upload",
                  {
                    ref: "upload",
                    staticClass: "upload-demo",
                    attrs: {
                      drag: "",
                      action: "",
                      multiple: "",
                      "http-request": _vm.upload,
                      "before-upload": _vm.uploadBefore,
                      "file-list": _vm.fileList,
                    },
                  },
                  [
                    _c("i", { staticClass: "el-icon-upload" }),
                    _c("div", { staticClass: "el-upload__text" }, [
                      _vm._v("将文件拖到此处，或"),
                      _c("em", [_vm._v("点击上传")]),
                    ]),
                    _c(
                      "div",
                      {
                        staticClass: "el-upload__tip",
                        attrs: { slot: "tip" },
                        slot: "tip",
                      },
                      [_vm._v("直接导入已填好的Excel列表，仅支持XLS/XLSX")]
                    ),
                  ]
                ),
                _vm.errorList.length > 0
                  ? _c(
                      "div",
                      { staticClass: "err-box" },
                      [
                        _c(
                          "el-link",
                          {
                            attrs: { icon: "el-icon-warning", type: "danger" },
                          },
                          [
                            _vm._v(
                              "Excel导入出错，请检查错误行，然后将错误行重新导入"
                            ),
                          ]
                        ),
                        _vm._l(_vm.errorList, function (item) {
                          return _c(
                            "div",
                            { key: item.row },
                            [
                              _c("el-link", { attrs: { type: "danger" } }, [
                                _vm._v(
                                  "第" +
                                    _vm._s(item.row) +
                                    "行" +
                                    _vm._s(item.error)
                                ),
                              ]),
                            ],
                            1
                          )
                        }),
                      ],
                      2
                    )
                  : _vm._e(),
              ],
              1
            ),
          ]
        ),
        _c(
          "a-modal",
          {
            attrs: {
              title: "执行车系",
              visible: _vm.showCarSeries,
              width: "40%",
            },
            on: {
              "update:visible": function ($event) {
                _vm.showCarSeries = $event
              },
              cancel: function () {
                return (_vm.showCarSeries = false)
              },
            },
          },
          [
            _c(
              "vxe-table",
              {
                ref: "xTable",
                staticClass: "mytable-scrollbar",
                staticStyle: { "margin-top": "10px" },
                attrs: {
                  border: "",
                  "show-header-overflow": "",
                  "show-overflow": "",
                  "column-config": { resizable: true },
                  stripe: "",
                  round: "",
                  "max-height":
                    _vm.$store.state.app.height - 350 < 185
                      ? 185
                      : _vm.$store.state.app.height - 350,
                  "scroll-y": { enabled: false },
                  "row-config": { isHover: true },
                  data: _vm.carStrainList,
                },
              },
              [
                _c("vxe-column", {
                  attrs: {
                    type: "seq",
                    title: "序号",
                    width: "60",
                    align: "center",
                  },
                }),
                _c("vxe-column", {
                  attrs: { title: "品系", field: "strains", align: "center" },
                }),
                _c("vxe-column", {
                  attrs: { title: "车系", field: "carSeries", align: "center" },
                }),
              ],
              1
            ),
            _c(
              "span",
              {
                staticClass: "dialog-footer",
                attrs: { slot: "footer" },
                slot: "footer",
              },
              [
                _c(
                  "vxe-button",
                  {
                    on: {
                      click: function ($event) {
                        _vm.showCarSeries = false
                      },
                    },
                  },
                  [_vm._v("关 闭")]
                ),
              ],
              1
            ),
          ],
          1
        ),
        _c(
          "a-modal",
          {
            attrs: { title: "编辑", visible: _vm.editDialog, width: "30%" },
            on: {
              "update:visible": function ($event) {
                _vm.editDialog = $event
              },
              cancel: _vm.editCancel,
            },
          },
          [
            _c(
              "a-form-model",
              {
                ref: "editDealerForm",
                staticClass: "UniformCss",
                attrs: {
                  inline: true,
                  model: _vm.editData,
                  rules: _vm.dealerRules,
                  "label-width": "100px",
                },
              },
              [
                _c(
                  "a-row",
                  [
                    _c(
                      "a-col",
                      [
                        _c(
                          "a-form-model-item",
                          { attrs: { label: "经销商:" } },
                          [
                            _c("a-input", {
                              attrs: { disabled: "" },
                              model: {
                                value: _vm.editData.dealerName,
                                callback: function ($$v) {
                                  _vm.$set(_vm.editData, "dealerName", $$v)
                                },
                                expression: "editData.dealerName",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "a-col",
                      [
                        _c(
                          "a-form-model-item",
                          {
                            attrs: { label: "费用额度(元):", prop: "feeLimit" },
                          },
                          [
                            _c("a-input", {
                              attrs: {
                                placeholder: "费用额度",
                                clearable: "",
                                oninput: "value=value.replace(/[^\\d]/g, '')",
                              },
                              model: {
                                value: _vm.editData.feeLimit,
                                callback: function ($$v) {
                                  _vm.$set(_vm.editData, "feeLimit", $$v)
                                },
                                expression: "editData.feeLimit",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "a-col",
                      [
                        _c(
                          "a-form-model-item",
                          {
                            attrs: { label: "核销比例(%):", prop: "writeRate" },
                          },
                          [
                            _c("a-input", {
                              attrs: { placeholder: "核销比例", clearable: "" },
                              on: {
                                input: function ($event) {
                                  return _vm.handleWriteRateInput()
                                },
                              },
                              model: {
                                value: _vm.editData.writeRate,
                                callback: function ($$v) {
                                  _vm.$set(_vm.editData, "writeRate", $$v)
                                },
                                expression: "editData.writeRate",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "a-col",
                      [
                        _c(
                          "a-form-model-item",
                          {
                            attrs: { label: "执行频次:", prop: "executeFreq" },
                          },
                          [
                            _c("a-input", {
                              attrs: {
                                placeholder: "执行频次",
                                clearable: "",
                                oninput: "value=value.replace(/[^\\d]/g, '')",
                              },
                              model: {
                                value: _vm.editData.executeFreq,
                                callback: function ($$v) {
                                  _vm.$set(_vm.editData, "executeFreq", $$v)
                                },
                                expression: "editData.executeFreq",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "span",
              {
                staticClass: "dialog-footer",
                attrs: { slot: "footer" },
                slot: "footer",
              },
              [
                _c("vxe-button", { on: { click: _vm.editCancel } }, [
                  _vm._v("取 消"),
                ]),
                _c(
                  "vxe-button",
                  {
                    attrs: { status: "primary" },
                    on: { click: _vm.editConfirm },
                  },
                  [_vm._v("确 定")]
                ),
              ],
              1
            ),
          ],
          1
        ),
        _c(
          "el-dialog",
          {
            attrs: {
              title: "添加经销商列表",
              visible: _vm.dealerAddDialogVisible,
              width: "80%",
              "before-close": _vm.handleDealerAddDialogBeforeClose,
            },
            on: {
              "update:visible": function ($event) {
                _vm.dealerAddDialogVisible = $event
              },
            },
          },
          [
            _c(
              "div",
              { staticClass: "usereq" },
              [
                _c(
                  "div",
                  [
                    _c(
                      "el-form",
                      {
                        staticStyle: {
                          margin: "0px",
                          height: "auto",
                          padding: "0px 10px",
                          "vertical-align": "middle",
                        },
                        attrs: { inline: true },
                      },
                      [
                        _c(
                          "SiftDealer",
                          { attrs: { base: _vm.base } },
                          [
                            _c(
                              "template",
                              { slot: "ButtonTwo" },
                              [
                                _c(
                                  "el-form-item",
                                  { staticStyle: { margin: "10px" } },
                                  [
                                    _c(
                                      "vxe-button",
                                      {
                                        staticStyle: {
                                          background: "#1b81ef",
                                          border: "0px",
                                        },
                                        attrs: { status: "primary" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.handleQueryByPageInDealerAddDialog(
                                              1
                                            )
                                          },
                                        },
                                      },
                                      [_vm._v("搜索")]
                                    ),
                                    _c(
                                      "vxe-button",
                                      {
                                        on: {
                                          click:
                                            _vm.handleClearDataInDealerAddDialog,
                                        },
                                      },
                                      [_vm._v("重置")]
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          2
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "a-row",
                  { attrs: { gutter: 1 } },
                  [
                    _c("a-col", { attrs: { span: 12 } }, [
                      _c(
                        "div",
                        { staticClass: "left_content" },
                        [
                          _c(
                            "vxe-table",
                            {
                              directives: [
                                {
                                  name: "loading",
                                  rawName: "v-loading",
                                  value: _vm.dealerAddPageDataSearchLoading,
                                  expression: "dealerAddPageDataSearchLoading",
                                },
                              ],
                              ref: "table1",
                              staticClass: "mytable-scrollbar",
                              staticStyle: { "margin-top": "10px" },
                              attrs: {
                                border: "",
                                "show-header-overflow": "",
                                "show-overflow": "",
                                "column-config": { resizable: true },
                                stripe: "",
                                round: "",
                                "max-height": "370",
                                "scroll-y": { enabled: false },
                                "row-config": { isHover: true },
                                data: _vm.dealerAddDialogAllDealerList,
                                "checkbox-config":
                                  _vm.checkboxConfigInDealerAddDialog,
                              },
                              on: {
                                "checkbox-change": function ($event) {
                                  return _vm.handleCheckedLeftChange(
                                    $event.records
                                  )
                                },
                                "checkbox-all": function ($event) {
                                  return _vm.handleCheckedLeftChange(
                                    $event.records
                                  )
                                },
                              },
                            },
                            [
                              _c("vxe-column", {
                                attrs: {
                                  type: "checkbox",
                                  width: "60",
                                  align: "center",
                                },
                              }),
                              _c("vxe-column", {
                                attrs: {
                                  type: "seq",
                                  title: "序号",
                                  width: "60",
                                  align: "center",
                                },
                              }),
                              _c("vxe-column", {
                                attrs: {
                                  title: "经理部",
                                  field: "sectorName",
                                  width: "100",
                                },
                              }),
                              _c("vxe-column", {
                                attrs: {
                                  title: "经销商名称",
                                  field: "dealerName",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ]),
                    _c("a-col", { attrs: { span: 1 } }, [
                      _c(
                        "div",
                        { staticClass: "move-btn-container" },
                        [
                          _c("vxe-button", {
                            attrs: {
                              type: "primary",
                              icon: "el-icon-arrow-right",
                              circle: "",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.putDealerDataToRight()
                              },
                            },
                          }),
                          _c("vxe-button", {
                            staticStyle: { margin: "20px 0 0 0" },
                            attrs: {
                              type: "primary",
                              icon: "el-icon-arrow-left",
                              circle: "",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.putDealerDataToLeft()
                              },
                            },
                          }),
                        ],
                        1
                      ),
                    ]),
                    _c("a-col", { attrs: { span: 11 } }, [
                      _c(
                        "div",
                        { staticClass: "left_content" },
                        [
                          _c(
                            "vxe-table",
                            {
                              directives: [
                                {
                                  name: "loading",
                                  rawName: "v-loading",
                                  value: _vm.dealerAddPageDataSearchLoading,
                                  expression: "dealerAddPageDataSearchLoading",
                                },
                              ],
                              ref: "table2",
                              staticClass: "mytable-scrollbar",
                              staticStyle: { "margin-top": "10px" },
                              attrs: {
                                border: "",
                                "show-header-overflow": "",
                                "show-overflow": "",
                                "column-config": { resizable: true },
                                stripe: "",
                                round: "",
                                "max-height": "370",
                                "scroll-y": { enabled: false },
                                "row-config": { isHover: true },
                                data: _vm.dealerAddDialogSelectedDealerList,
                              },
                              on: {
                                "checkbox-change": function ($event) {
                                  return _vm.rhandleCheckedLeftChange(
                                    $event.records
                                  )
                                },
                                "checkbox-all": function ($event) {
                                  return _vm.rhandleCheckedLeftChange(
                                    $event.records
                                  )
                                },
                              },
                            },
                            [
                              _c("vxe-column", {
                                attrs: {
                                  type: "checkbox",
                                  width: "60",
                                  align: "center",
                                },
                              }),
                              _c("vxe-column", {
                                attrs: {
                                  type: "seq",
                                  title: "序号",
                                  width: "60",
                                  align: "center",
                                },
                              }),
                              _c("vxe-column", {
                                attrs: {
                                  title: "经理部",
                                  field: "sectorName",
                                  width: "100",
                                },
                              }),
                              _c("vxe-column", {
                                attrs: {
                                  title: "经销商名称",
                                  field: "dealerName",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ]),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "footer-btn-box" },
                  [
                    _c(
                      "vxe-button",
                      { on: { click: _vm.handleDealerAddDialogBeforeClose } },
                      [_vm._v("关闭")]
                    ),
                    _c(
                      "vxe-button",
                      {
                        attrs: { status: "primary" },
                        on: { click: _vm.submitDistributorSelect },
                      },
                      [_vm._v("确认")]
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ]
        ),
        _c(
          "a-modal",
          {
            attrs: {
              title: "批量修改执行频次",
              visible: _vm.editExecuteFreqVisible,
              width: "30%",
            },
            on: {
              "update:visible": function ($event) {
                _vm.editExecuteFreqVisible = $event
              },
              cancel: function ($event) {
                _vm.editExecuteFreqVisible = false
              },
            },
          },
          [
            _c(
              "a-form-model",
              {
                staticClass: "UniformCss",
                attrs: { inline: true, "label-width": "100px" },
              },
              [
                _c(
                  "a-form-model-item",
                  { attrs: { label: "执行频次:" } },
                  [
                    _c("a-input", {
                      attrs: {
                        placeholder: "执行频次",
                        clearable: "",
                        oninput: "value=value.replace(/[^\\d]/g, '')",
                      },
                      model: {
                        value: _vm.newExecuteFreq,
                        callback: function ($$v) {
                          _vm.newExecuteFreq = $$v
                        },
                        expression: "newExecuteFreq",
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "span",
              {
                staticClass: "dialog-footer",
                attrs: { slot: "footer" },
                slot: "footer",
              },
              [
                _c(
                  "vxe-button",
                  {
                    on: {
                      click: function ($event) {
                        _vm.editExecuteFreqVisible = false
                      },
                    },
                  },
                  [_vm._v("取 消")]
                ),
                _c(
                  "vxe-button",
                  {
                    attrs: {
                      status: "primary",
                      loading: _vm.editBatchExecuteFreqLoading,
                    },
                    on: { click: _vm.editBatchExecuteFreq },
                  },
                  [_vm._v("确 定")]
                ),
              ],
              1
            ),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }